"use client";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import "./countDown.css";

interface CountDownProps {
  offerTimerValid: any;
  expireIn: any;
  /** Flex alignment of the flip clock row (default matches previous end-aligned layout). */
  justifyContent?: "flex-start" | "center" | "flex-end";
  className?: string;
}

const CountDown: React.FC<CountDownProps> = ({
  offerTimerValid,
  expireIn,
  justifyContent = "flex-end",
  className,
}) => {
  const [count, setCount] = useState(expireIn);

  useEffect(() => {
    let countDown: any;
    if (count > 0) {
      countDown = setTimeout(() => {
        setCount((prevCount: any) => prevCount - 1);
      }, 1000);
    }
    return () => clearInterval(countDown);
  }, [count]);

  // const formatTime = (time: number) => {
  //   //------------------days--------------
  //   const days = Math.floor(time / (60 * 60 * 24));
  //   const formatedDays = days < 10 ? `0${days}` : days;
  //   const splitDays = formatedDays.toString().split("");
  //   //------------------hour--------------
  //   const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60));
  //   const formatedHour = hours < 10 ? `0${hours}` : hours;
  //   const splitHour = formatedHour.toString().split("");
  //   //------------------minute--------------
  //   const minutes = Math.floor((time % (60 * 60)) / 60);
  //   const formatedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  //   const splitMinutes = formatedMinutes.toString().split("");
  //   //------------------seconds--------------
  //   const seconds = time % 60;
  //   const formatedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  //   const splitSeconds = formatedSeconds.toString().split("");

  //   return (
  //     <Box sx={{ display: "flex" }}>
  //       {splitDays.map((item, i) => (
  //         <Typography
  //           variant="caption"
  //           sx={{
  //             background: "#a1f3a2",
  //             margin: "0.5px",
  //             padding: "0px 1px",
  //             borderRadius: "2px",
  //             fontWeight: "600",
  //           }}
  //           key={i}
  //         >
  //           {item}
  //         </Typography>
  //       ))}
  //       <span style={{ color: "#a1f3a2", fontWeight: "bold", margin: "0.5px" }}>
  //         :
  //       </span>
  //       {splitHour.map((item, i) => (
  //         <Typography
  //           variant="caption"
  //           sx={{
  //             background: "#a1f3a2",
  //             margin: "0.5px",
  //             padding: "0px 1px",
  //             borderRadius: "2px",
  //             fontWeight: "600",
  //           }}
  //           key={i}
  //         >
  //           {item}
  //         </Typography>
  //       ))}
  //       <span style={{ color: "#a1f3a2", fontWeight: "bold", margin: "0.5px" }}>
  //         :
  //       </span>
  //       {splitMinutes.map((item, i) => (
  //         <Typography
  //           variant="caption"
  //           sx={{
  //             background: "#a1f3a2",
  //             margin: "0.5px",
  //             padding: "0px 1px",
  //             borderRadius: "2px",
  //             fontWeight: "600",
  //           }}
  //           key={i}
  //         >
  //           {item}
  //         </Typography>
  //       ))}
  //       <span style={{ color: "#a1f3a2", fontWeight: "bold", margin: "0.5px" }}>
  //         :
  //       </span>
  //       {splitSeconds.map((item, i) => (
  //         <Typography
  //           variant="caption"
  //           sx={{
  //             background: "#a1f3a2",
  //             margin: "0.5px",
  //             padding: "0px 1px",
  //             borderRadius: "2px",
  //             fontWeight: "600",
  //           }}
  //           key={i}
  //         >
  //           {item}
  //         </Typography>
  //       ))}
  //     </Box>
  //   );
  // };

  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        justifyContent,
        alignItems: "center",
        flexWrap: "wrap",
        gap: 0.5,
        minHeight: 28,
      }}
    >
      {!offerTimerValid ? (
        <Typography variant="caption" sx={{ color: "white" }}>
          Expire In&nbsp;
        </Typography>
      ) : (
        ""
      )}
      {/* <Box>
        <Typography
          variant="caption"
          sx={{ color: "black", fontWeight: "bold" }}
        >
          {formatTime(count)}
        </Typography>
      </Box> */}
      <Box>
        <FlipClockCountdown
          to={new Date().getTime() + count * 1000}
          showLabels={false}
          className="flip-clock"
          digitBlockStyle={{
            fontSize: "12px",
            background: "#a1f3a2",
            color: "#000",
            fontWeight: "600",
            width: 10,
            height: 22,
            borderRadius: "4px",
            boxShadow: "none",
          }}
          separatorStyle={{
            color: "#a1f3a2",
            size: "2px",
          }}
          dividerStyle={{
            color: "#fff",
            height: "0px",
          }}
        />
      </Box>
    </Box>
  );
};

export default CountDown;
